<template>
  <div class="wrapper">
    <div class="detail-content1"><p><img src="../../../../static/images/product/modernPropertyInsurance/productDetail.png" alt="" width="100%" height="auto"></p></div>
    <div class="space-between functionUnit">
      <div class="submitBtn" @click="submitBtn()">立即申请</div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "buyerPaymentGuaranteeInsurance",
      data() {
        return {

        };
      },
      methods: {
        submitBtn() {
          let that = this;

          that.$$.alert({message: "请联系平台客服投保", type: "success",});
        }
      },
      mounted() {

      },
    }
</script>

<style scoped>
  .wrapper{
    padding: 20px 20%;
  }

  .submitBtn {
    width: 100%;
    height: 45px;
    line-height: 45px;
    border-radius: 8px;
    text-align: center;
    background-color: #FF7052;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/modernPropertyInsurance/buyerPaymentGuaranteeInsurance.vue